module.exports = __webpack_public_path__ + "public/img/logo-aprindo.4bb3cbf7.jpg";